export default {
    items: [
        {
            name: 'Controle de Acesso',
            url: '/controleacesso',
            icon: 'fa fa-vcard-o',
            badge: {
                variant: 'primary',
                text: ''
            },
            regras: ['CTRLACS-USR-00', 'CTRLACS-PA-00', 'CTRLACS-RA-00'],
            children: [
                {
                    name: 'Usuários',
                    url: '/controleacesso/usuarios',
                    icon: 'fa fa-users',
                    regras: 'CTRLACS-USR-00'
                },
                {
                    name: 'Perfis de Acesso',
                    url: '/controleacesso/perfisacesso',
                    icon: 'fa fa-user-secret',
                    regras: 'CTRLACS-PA-00'
                },
                {
                    name: 'Regras de Acesso',
                    url: '/controleacesso/regrasacesso',
                    icon: 'fa fa-key',
                    regras: 'CTRLACS-RA-00'
                },
                {
                    name: 'Aplicações',
                    url: '/controleacesso/aplicacoes',
                    icon: 'fa fa-code',
                    regras: 'CTRLACS-APP-00'
                }
            ]
        },
        {
            name: 'Admin',
            url: '/admin',
            icon: 'fa fa-gear',
            badge: {
                variant: 'primary',
                text: ''
            },
            regras: [
                'ADMIN-TIPOMOV-00',
                'ADMIN-COMPR-00',
                'ADMIN-PARAMETROS-00'
            ],
            children: [
                {
                    name: 'Tipos de Movimentos',
                    url: '/admin/tiposmovimentos',
                    icon: 'fa fa-file-text-o',
                    regras: 'ADMIN-TIPOMOV-00'
                },
                {
                    name: 'Excluir Comprometimentos',
                    url: '/admin/comprometimentos/excluir-em-lote',
                    icon: 'fa fa-trash',
                    regras: 'ADMIN-COMPR-00'
                },
                {
                    name: 'Parâmetros',
                    url: '/admin/parametros',
                    icon: 'fa fa-cogs',
                    regras: 'ADMIN-PARAMETROS-00'
                },
                {
                    name: 'Modelos',
                    url: '/admin/modelos',
                    icon: 'fa fa-file-text-o',
                    regras: 'ADMIN-MODELOS-00'
                }
            ]
        },
        {
            name: 'Contratos',
            url: '/contratos',
            icon: 'fa fa-file-text-o',
            regras: ['CONT-00']
        },
        {
            name: 'Requisições',
            url: '/contratos/requisicoes',
            icon: 'fa fa-file-text-o',
            regras: ['CONT-REQ-00']
        },
        {
            name: 'Serviços',
            url: '/contratos/servicos',
            icon: 'fa fa-truck',
            regras: ['CONT-COMPR-10']
        },
        {
            name: 'Pagamentos',
            url: '/contratos/pagamentos',
            icon: 'fa fa-dollar',
            regras: ['CONT-PAG-00']
        },
        {
            name: 'Relatórios Contratos',
            url: '/contratos/relatorios',
            icon: 'fa fa-file-o',
            regras: ['CONT-REL-00']
        },
        // {
        //     name: 'Convênios',
        //     url: '/convenios',
        //     icon: 'fa fa-file-text-o',
        //     regras: ['CONV-00']
        // },
        // {
        //     name: 'Atestos',
        //     url: '/atestos',
        //     icon: 'fa fa-check-circle-o',
        //     regras: ['CONT-ATESTOS-00']
        // },
        // {
        //     name: 'Certidões',
        //     url: '/certidoes',
        //     icon: 'fa fa-file-o',
        //     regras: ['CERT-00']
        // }
    ]

    // items: [{
    //         name: 'Dashboard',
    //         url: '/dashboard',
    //         icon: 'icon-speedometer',
    //         badge: {
    //             variant: 'primary',
    //             text: 'NEW'
    //         },
    //         regras: ['CTRLACS-USR-00']
    //     },
    //     {
    //         title: true,
    //         name: 'Theme',
    //         class: '',
    //         wrapper: {
    //             element: '',
    //             attributes: {}
    //         }
    //     },
    //     {
    //         name: 'Colors',
    //         url: '/theme/colors',
    //         icon: 'icon-drop'
    //     },
    //     {
    //         name: 'Typography',
    //         url: '/theme/typography',
    //         icon: 'icon-pencil'
    //     },
    //     {
    //         title: true,
    //         name: 'Components',
    //         class: '',
    //         wrapper: {
    //             element: '',
    //             attributes: {}
    //         }
    //     },
    //     {
    //         name: 'Base',
    //         url: '/base',
    //         icon: 'icon-puzzle',
    //         regras: ['CTRLACS-USR-00'],
    //         children: [{
    //                 name: 'Breadcrumbs',
    //                 url: '/base/breadcrumbs',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Cards',
    //                 url: '/base/cards',
    //                 icon: 'icon-puzzle',
    //                 regras: ['CTRLACS-USR-99']
    //             },
    //             {
    //                 name: 'Carousels',
    //                 url: '/base/carousels',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Collapses',
    //                 url: '/base/collapses',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Forms',
    //                 url: '/base/forms',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Jumbotrons',
    //                 url: '/base/jumbotrons',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'List Groups',
    //                 url: '/base/list-groups',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Navs',
    //                 url: '/base/navs',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Navbars',
    //                 url: '/base/navbars',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Paginations',
    //                 url: '/base/paginations',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Popovers',
    //                 url: '/base/popovers',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Progress Bars',
    //                 url: '/base/progress-bars',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Switches',
    //                 url: '/base/switches',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Tables',
    //                 url: '/base/tables',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Tabs',
    //                 url: '/base/tabs',
    //                 icon: 'icon-puzzle'
    //             },
    //             {
    //                 name: 'Tooltips',
    //                 url: '/base/tooltips',
    //                 icon: 'icon-puzzle'
    //             }
    //         ]
    //     },
    //     {
    //         name: 'Buttons',
    //         url: '/buttons',
    //         icon: 'icon-cursor',
    //         children: [{
    //                 name: 'Buttons',
    //                 url: '/buttons/standard-buttons',
    //                 icon: 'icon-cursor'
    //             },
    //             {
    //                 name: 'Button Dropdowns',
    //                 url: '/buttons/dropdowns',
    //                 icon: 'icon-cursor'
    //             },
    //             {
    //                 name: 'Button Groups',
    //                 url: '/buttons/button-groups',
    //                 icon: 'icon-cursor'
    //             },
    //             {
    //                 name: 'Brand Buttons',
    //                 url: '/buttons/brand-buttons',
    //                 icon: 'icon-cursor'
    //             }
    //         ]
    //     },
    //     {
    //         name: 'Charts',
    //         url: '/charts',
    //         icon: 'icon-pie-chart'
    //     },
    //     {
    //         name: 'Icons',
    //         url: '/icons',
    //         icon: 'icon-star',
    //         children: [{
    //                 name: 'CoreUI Icons',
    //                 url: '/icons/coreui-icons',
    //                 icon: 'icon-star',
    //                 badge: {
    //                     variant: 'info',
    //                     text: 'NEW'
    //                 }
    //             },
    //             {
    //                 name: 'Flags',
    //                 url: '/icons/flags',
    //                 icon: 'icon-star'
    //             },
    //             {
    //                 name: 'Font Awesome',
    //                 url: '/icons/font-awesome',
    //                 icon: 'icon-star',
    //                 badge: {
    //                     variant: 'secondary',
    //                     text: '4.7'
    //                 }
    //             },
    //             {
    //                 name: 'Simple Line Icons',
    //                 url: '/icons/simple-line-icons',
    //                 icon: 'icon-star'
    //             }
    //         ]
    //     },
    //     {
    //         name: 'Notifications',
    //         url: '/notifications',
    //         icon: 'icon-bell',
    //         children: [{
    //                 name: 'Alerts',
    //                 url: '/notifications/alerts',
    //                 icon: 'icon-bell'
    //             },
    //             {
    //                 name: 'Badges',
    //                 url: '/notifications/badges',
    //                 icon: 'icon-bell'
    //             },
    //             {
    //                 name: 'Modals',
    //                 url: '/notifications/modals',
    //                 icon: 'icon-bell'
    //             }
    //         ]
    //     },
    //     {
    //         name: 'Widgets',
    //         url: '/widgets',
    //         icon: 'icon-calculator',
    //         badge: {
    //             variant: 'primary',
    //             text: 'NEW'
    //         }
    //     },
    //     {
    //         divider: true
    //     },
    //     {
    //         title: true,
    //         name: 'Extras'
    //     },
    //     {
    //         name: 'Pages',
    //         url: '/pages',
    //         icon: 'icon-star',
    //         children: [{
    //                 name: 'Login',
    //                 url: '/pages/login',
    //                 icon: 'icon-star'
    //             },
    //             {
    //                 name: 'Register',
    //                 url: '/pages/register',
    //                 icon: 'icon-star'
    //             },
    //             {
    //                 name: 'Error 404',
    //                 url: '/pages/404',
    //                 icon: 'icon-star'
    //             },
    //             {
    //                 name: 'Error 500',
    //                 url: '/pages/500',
    //                 icon: 'icon-star'
    //             }
    //         ]
    //     },
    //     {
    //         name: 'Disabled',
    //         url: '/dashboard',
    //         icon: 'icon-ban',
    //         badge: {
    //             variant: 'secondary',
    //             text: 'NEW'
    //         },
    //         attributes: {
    //             disabled: true
    //         },
    //     },
    //     {
    //         name: 'Download CoreUI',
    //         url: 'http://coreui.io/vue/',
    //         icon: 'icon-cloud-download',
    //         class: 'mt-auto',
    //         variant: 'success',
    //         attributes: {
    //             target: '_blank',
    //             rel: 'noopener'
    //         }
    //     },
    //     {
    //         name: 'Try CoreUI PRO',
    //         url: 'http://coreui.io/pro/vue/',
    //         icon: 'icon-layers',
    //         variant: 'danger',
    //         attributes: {
    //             target: '_blank',
    //             rel: 'noopener'
    //         }
    //     },
    // ]
}
